var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "LoginCard",
    { attrs: { "data-test-id": "UserLogin__EmailEntry" } },
    [
      _c(
        "h1",
        {
          class: _vm.$style.header,
          attrs: { "data-test-id": "UserLogin__EmailEntry__header" },
        },
        [_vm._v("\n    User Login\n  ")]
      ),
      _vm._v(" "),
      _c(
        "form",
        { attrs: { action: _vm.submit, autocomplete: "on", method: "post" } },
        [
          _c("LoginTextField", {
            attrs: {
              autoFocus: "",
              label: "Email",
              name: "email",
              placeholder: "User Email Address",
              required: "",
              submitOnEnter: _vm.submit,
              type: "email",
              vvName: "email",
            },
            model: {
              value: _vm.form.email,
              callback: function ($$v) {
                _vm.$set(_vm.form, "email", $$v)
              },
              expression: "form.email",
            },
          }),
          _vm._v(" "),
          _c("Checkbox", {
            class: _vm.$style.rememberEmail,
            attrs: { label: "Remember me" },
            model: {
              value: _vm.form.shouldRememberEmail,
              callback: function ($$v) {
                _vm.$set(_vm.form, "shouldRememberEmail", $$v)
              },
              expression: "form.shouldRememberEmail",
            },
          }),
          _vm._v(" "),
          _c(
            "LoginActionButton",
            {
              attrs: {
                action: _vm.submit,
                "data-automation": "loginButton",
                isLoading: _vm.isLoading,
                type: "submit",
              },
            },
            [_vm._v("\n      Continue\n    ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }